// connection to the backend data
// export const api_url = 'http://localhost:5000';

// connection to the hosted url
export const api_url = 'https://celebrate-precious.herokuapp.com';


